import "../../../styles/forms.scss";
import { useTranslation } from "react-i18next";
import DisabledTextArea from "../../../../components/DisabledTextArea";

export default function WorkExperienceFormPreview({ work }) {
  const { t } = useTranslation();

  return (
    <section className="form-group mt-4">
      <h1>{t("Work Experience")}</h1>
      <div className="row">
        <div className="form-group col-4">
          <div className="label-wrapper">
            <label htmlFor="professionalExperienceYearsId">
              {t("Years of Experience*")}
            </label>
          </div>
          <select
            id="ProfessionalExperienceYearsId"
            name="professionalExperienceYearsId"
            disabled
          >
            <option>{work?.professionalExperienceYears}</option>
          </select>
        </div>
        <div className="form-group col-4">
          <div className="label-wrapper">
            <label htmlFor="seniorityLevelsId">{t("Seniority Level")}</label>
          </div>
          <select id="SeniorityLevelsId" name="seniorityLevelsId" disabled>
            <option>{work?.seniorityLevel}</option>
          </select>
        </div>
      </div>
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="projectsExperienceDetails">
            {t("Main Activities*")}
          </label>
        </div>
        <DisabledTextArea
          id="projectsExperienceDetails"
          rows={work?.projectsExperienceDetails}
          name="projectsExperienceDetails"
          value={work?.projectsExperienceDetails}
          disabled
        />
      </div>
    </section>
  );
}
